import { render } from "./PreResearch.vue?vue&type=template&id=080a13ad&scoped=true"
import script from "./PreResearch.vue?vue&type=script&lang=js"
export * from "./PreResearch.vue?vue&type=script&lang=js"

import "./PreResearch.vue?vue&type=style&index=0&id=080a13ad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.30_vue@3.5.30_webpack@5.105.4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-080a13ad"]])

export default __exports__